export const maxFileSize = 2;
export const fileTypes = '.png, .jpg, .jpeg';
